<template>
  <div>
    <t-form labelWidth="80px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
      <t-form-item label="默认状态" help="0">
        <div @click="showGallery('0')" class="img-block">
          <div v-show="!attribute.urls['0']" class="upload-block">+</div>
          <t-image style="width: 100%;height: 100%" fit="contain" v-if="attribute.urls['0']" :src="fileUrl + attribute.urls['0']"/>
          <div class="del-block" @click.stop="clearImg('0')" v-show="attribute.urls['0']"><t-icon name="delete"/></div>
        </div>
      </t-form-item>
      <t-form-item label="占用状态" help="1">
        <div @click="showGallery('1')" class="img-block">
          <div v-show="!attribute.urls['1']" class="upload-block">+</div>
          <t-image style="width: 100%;height: 100%" fit="contain" v-if="attribute.urls['1']" :src="fileUrl + attribute.urls['1']"/>
          <div class="del-block" @click.stop="clearImg('1')" v-show="attribute.urls['1']"><t-icon name="delete"/></div>
        </div>
      </t-form-item>
      <t-form-item label="告警状态" help="2">
        <div @click="showGallery('2')" class="img-block">
          <div v-show="!attribute.urls['2']" class="upload-block">+</div>
          <t-image style="width: 100%;height: 100%" fit="contain" v-if="attribute.urls['2']" :src="fileUrl + attribute.urls['2']"/>
          <div class="del-block" @click.stop="clearImg('2')" v-show="attribute.urls['2']"><t-icon name="delete"/></div>
        </div>
      </t-form-item>
      <t-form-item label="故障状态" help="3">
        <div @click="showGallery('3')" class="img-block">
          <div v-show="!attribute.urls['3']" class="upload-block">+</div>
          <t-image style="width: 100%;height: 100%" fit="contain" v-if="attribute.urls['3']" :src="fileUrl + attribute.urls['3']"/>
          <div class="del-block" @click.stop="clearImg('3')" v-show="attribute.urls['3']"><t-icon name="delete"/></div>
        </div>
      </t-form-item>
    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck"/>
  </div>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
import Gallery from "@/components/designer/gallery";
import {fileUrl} from "/env";

export default {
  name: "cpt-img-state-option",
  components: {Gallery,CptData},
  props: {attribute: Object, cptDataForm:Object,},
  data(){
    return {
      currState:'',
      fileUrl
    }
  },
  methods:{
    showGallery(state){
      this.currState = state;
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl){
      this.attribute.urls[this.currState] = fileUrl
    },
    clearImg(key){
      this.attribute.urls[key] = ''
    }
  }
}
</script>

<style scoped>
.img-block{width: 150px; height: 120px; position: relative;cursor: pointer}
.upload-block{width: 100%;height: 100%;text-align: center;font-size: 40px;line-height: 120px;border: 1px solid #ccc}
.del-block{width: 30px;height: 30px;top:0;right: 0;position: absolute;z-index: 2}
</style>
